import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Loader2 } from 'lucide-react';
import { Logo } from '../shell/Logo';
import { forgotPassword } from '../api/authApi';

// 보안: 서버는 계정 존재 여부와 무관하게 동일 응답 (§6.0.6). UI 도 그에 맞춰 동일 안내.
export default function ForgotPasswordPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setSubmitting(true);
    try {
      await forgotPassword(email);
    } catch {
      // 서버 에러도 UX 상 동일 응답으로 노출 (타이밍 공격 방지 차원)
    } finally {
      setSent(true);
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <div className="auth-page">
        <div className="auth-form">
          <div className="auth-form__brand">
            <Logo size={20} showText={false} />
            <span className="auth-form__brand-name">Alpha Omega Quant</span>
          </div>
          <h1>재설정 메일 발송</h1>
          <p>입력하신 이메일이 가입된 계정이라면 재설정 링크가 발송됩니다. 메일함을 확인해주세요.</p>
          <Link to="/login">로그인으로</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-form__brand">
          <Logo size={20} showText={false} />
          <span className="auth-form__brand-name">Alpha Omega Quant</span>
        </div>
        <h1>비밀번호 재설정</h1>
        <label>
          <span>가입한 이메일</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <button type="submit" disabled={submitting}>
          {submitting ? (
            <Loader2 size={16} strokeWidth={1.75} className="pca-spin" />
          ) : (
            <Mail size={16} strokeWidth={1.75} />
          )}
          {submitting ? '발송 중...' : '재설정 링크 받기'}
        </button>
        <div className="auth-links">
          <Link to="/login">로그인으로</Link>
        </div>
      </form>
    </div>
  );
}
